<template>
    <div>
        <div class="form">
            <div class="form-row">
                <div class="form-row__col">
                    <label class="label">{{
                        trans('sales_metrics.label.select_tenant')
                    }}</label>
                    <v-select
                        v-model="tenantSelected"
                        :options="tenantOptions"
                        :clearable="false"
                        class="form-vue-select"
                        multiple
                        @input="tenantSelectionChanged"
                    >
                        <div slot="no-options">
                            {{ trans('vue_select.no_options') }}
                        </div>
                    </v-select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-row__col">
                    <label class="label">{{
                        trans('sales_metrics.label.select_type')
                    }}</label>
                    <v-select
                        v-model="typeSelected"
                        :options="typeOptions"
                        :placeholder="trans('sales_metrics.placeholder_type')"
                        :clearable="false"
                        class="form-vue-select"
                        @input="typeSelectionChanged"
                    >
                        <div slot="no-options">
                            {{ trans('vue_select.no_options') }}
                        </div>
                    </v-select>
                </div>
                <div class="form-row__col">
                    <label class="label">{{
                        trans('sales_metrics.label.select_subtype')
                    }}</label>
                    <v-select
                        v-model="subtypeSelected"
                        :options="subtypeOptions"
                        :placeholder="
                            trans('sales_metrics.placeholder_subtype')
                        "
                        :clearable="false"
                        :disabled="disableSubtypesSelect"
                        class="form-vue-select"
                        @input="subtypeSelectionChanged"
                    >
                        <div slot="no-options">
                            {{ trans('vue_select.no_options') }}
                        </div>
                    </v-select>
                </div>
                <div class="form-row__col">
                    <form-date
                        name="start_date"
                        :max-date="maxStartDate"
                        :required="true"
                        v-model="selectedStartDate"
                    >
                        {{ trans('users.label.start_date') }}
                    </form-date>
                </div>
                <div class="form-row__col">
                    <form-date
                        name="end_date"
                        :min-date="minEndDate"
                        :max-date="maxEndDate"
                        :required="true"
                        v-model="selectedEndDate"
                    >
                        {{ trans('users.label.end_date') }}
                    </form-date>
                </div>
            </div>
        </div>
        <div class="h:margin-top-6">
            <canvas :id="'chart-' + id" width="400" height="100"></canvas>
        </div>
    </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

export default {
    props: ['tenants', 'courses', 'id'],

    data() {
        return {
            results: null,

            typeSelected: null,
            typeOptions: [
                {
                    label: this.trans('sales_metrics.label.clients'),
                    value: 'clients',
                },
                {
                    label: this.trans('sales_metrics.label.users'),
                    value: 'users',
                },
                {
                    label: this.trans('sales_metrics.label.licenses'),
                    value: 'licenses',
                },
                {
                    label: this.trans(
                        'sales_metrics.label.new_course_progresses'
                    ),
                    value: 'new_course_progresses',
                },
            ],
            subtypeSelected: null,
            subtypeOptions: [],
            disableSubtypesSelect: true,

            tenantSelected: [
                { label: this.trans('sales_metrics.all_tenants'), value: 0 },
            ],
            tenantOptions: this.tenants,

            selectedStartDate: new Date(Date.now() - 30 * 24 * 3600 * 1000),
            selectedEndDate: new Date(Date.now() - 24 * 3600 * 1000)
                .toISOString()
                .substr(0, 10),
            maxEndDate: new Date(Date.now() - 24 * 3600 * 1000)
                .toISOString()
                .substr(0, 10),
            chart: null,
            graphColorArray: [
                '#007d40',
                '#08b3b5',
                '#084db5',
                '#52007d',
                '#af08b5',
                '#db8304',
                '#70ac23',
                '#36289d',
                '#b8ab1b',
                '#2a2a2a',
            ],
        };
    },

    computed: {
        chartLabels() {
            return this.results
                ? this.results.map(function(item) {
                      return item.date;
                  })
                : [];
        },
        chartData() {
            return this.results
                ? this.results.map(function(item) {
                      return item.amount;
                  })
                : [];
        },
        maxStartDate() {
            return this.selectedEndDate;
        },
        minEndDate() {
            return this.selectedStartDate;
        },
    },

    methods: {
        getData() {
            if (this.typeSelected == null || this.tenantSelected.length == 0) {
                return;
            }
            var tenantArray = this.tenantSelected.map(function(item) {
                return item.value;
            });
            var subtypeValue = this.subtypeSelected
                ? this.subtypeSelected.value
                : null;
            var filter = {
                type: this.typeSelected.value,
                subtype: subtypeValue,
                tenant: tenantArray,
                start_date: this.selectedStartDate,
                end_date: this.selectedEndDate,
            };
            axios
                .post(this.route('mainapi.sales_metrics.data'), filter)
                .then(response => {
                    this.results = response.data;
                    this.updateChart();
                });

            return;
        },
        tenantSelectionChanged() {
            this.getData();
        },
        typeSelectionChanged() {
            if (
                this.typeSelected.value == 'licenses' ||
                this.typeSelected.value == 'new_course_progresses'
            ) {
                this.disableSubtypesSelect = false;
                this.subtypeOptions = this.courses;
                this.subtypeSelected = {
                    label: this.trans('sales_metrics.all_courses'),
                    value: 0,
                };
            } else {
                this.disableSubtypesSelect = true;
                this.subtypeOptions = [];
                this.subtypeSelected = null;
            }
            this.getData();
        },
        subtypeSelectionChanged() {
            this.getData();
        },
        updateChart() {
            // remove old data
            this.chart.data.labels = [];
            this.chart.data.datasets = [];

            // add new data
            this.results.labels.forEach(item => {
                this.chart.data.labels.push(item);
            });

            this.results.datasets.forEach((tenant, index) => {
                this.chart.data.datasets.push({
                    label: tenant.label,
                    data: tenant.amountData,
                    borderWidth: 3,
                    borderColor: this.graphColorArray[index % 10],
                    backgroundColor: this.graphColorArray[index % 10],
                });
            });
            this.chart.update();
        },
        setupChart() {
            var ctx = document
                .getElementById('chart-' + this.id)
                .getContext('2d');
            this.chart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: '',
                            data: [],
                            borderWidth: 3,
                            borderColor: '#ffffff',
                            backgroundColor: '#ffffff',
                        },
                    ],
                },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                maxTicksLimit: 5,
                            },
                        },
                    },
                },
                legend: {
                    display: false,
                },
                title: {
                    display: true,
                    text: '',
                },
                tooltips: {
                    display: false,
                },
            });
        },
    },

    mounted() {
        this.getData();
        this.setupChart();
    },
};
</script>
